import { createRoot } from 'react-dom/client';

import { RootApp } from './root-app';

createRoot(document.querySelector('#root')!).render(<RootApp />);
